<template>
    <div class="vcs-triangles" v-bind:class="mode">
        <div class="vct-element-case"><div class="vct-element set-1"></div></div>
        <div class="vct-element-case"><div class="vct-element set-2 "></div></div>
        <div class="vct-element-case"><div class="vct-element set-3"></div></div>
        <div class="vct-element-case"><div class="vct-element set-4"></div></div>
        <div class="vct-element-case"><div class="vct-element set-5"></div></div>
        <div class="vct-element-case"><div class="vct-element set-6"></div></div>
        <div class="vct-element-case"><div class="vct-element set-7"></div></div>
        <div class="vct-element-case"><div class="vct-element set-8"></div></div>
        <div class="vct-element-case"><div class="vct-element set-9"></div></div>
        <div class="vct-element-case"><div class="vct-element set-10"></div></div>
        <div class="vct-element-case"><div class="vct-element set-11"></div></div>


    </div>     
</template>

<script>
export default {
  name: 'Triangles',
  props: {    
      mode: String
  },
  data() {
    return {      

    };
  },
  computed: {  
  },
  methods: {
   
  }
}
</script>


<style scoped >


.vcs-triangles.top-right { position: absolute; top: 0px; right: 0px; transition: all 0.4s; }
.vcs-triangles.bottom-left { position: absolute; top: 0px; left: -21px; transition: all 0.4s; transform: scale(-1, -1); }

 

.vcs-triangles .vct-element { position: absolute; width: 0; height: 0; border-top: 75px solid transparent; border-right: 150px solid rgba(255,255,255,0.15); border-bottom: 75px solid transparent; 
animation-name: base-fade-in;
animation-duration: 1s;
animation-timing-function: linear;
animation-delay: 0s;
animation-iteration-count: 1;
animation-fill-mode: forwards;
opacity: 0;
}
.vcs-triangles.top-right .vct-element-case { position: absolute; top: 0px; right: 0px; 

}



.vcs-triangles .vct-element.set-1 { animation-delay: 0s; top: 34px; right: 0px;  } 
.vcs-triangles .vct-element.set-2 { animation-delay: 0.2s; top: -40px; right: -22px; transform: scale(0.7); } 
.vcs-triangles .vct-element.set-3 { animation-delay: 0.8s; top: -40px; right: 44px; transform: scale(0.9); } 
.vcs-triangles .vct-element.set-4 { animation-delay: 1.2s; top: 35px; right: 70px; transform: scale(0.55) rotate(-16deg); } 
.vcs-triangles .vct-element.set-5 { animation-delay: 1.6s; top: -90px; right: 77px; transform: scale(0.55) rotate(16deg); } 
.vcs-triangles .vct-element.set-6 { animation-delay: 1.8s; top: -31px; right: 128px; transform: scale(0.7) rotate(-15deg); } 
.vcs-triangles .vct-element.set-7 { animation-delay: 2.2s; top: 10px; right: 144px; transform: scale(0.4) rotate(5deg); } 
.vcs-triangles .vct-element.set-8 { animation-delay: 2.6s; top: -20px; right: 184px; transform: scale(0.4) rotate(5deg); } 
.vcs-triangles .vct-element.set-9 { animation-delay: 2.8s; top: -55px; right: 210px; transform: scale(0.24) rotate(28deg); } 
.vcs-triangles .vct-element.set-10 { animation-delay: 3.0s; top: -0px; right: 230px; transform: scale(0.15) rotate(-18deg); } 
.vcs-triangles .vct-element.set-11 { animation-delay: 3.0s; top: 40px; right: 190px; transform: scale(0.15) rotate(-18deg); } 


@media only screen and (min-width: 1300px) {
  .vcs-triangles.top-right { transform: scale(1.3); }
  .vcs-triangles.bottom-left { transform: scale(-1.3, -1.6); }
}

@media only screen and (min-width: 1500px) {
  .vcs-triangles.top-right { transform: scale(1.6); }
  .vcs-triangles.bottom-left { transform: scale(-1.6, -1.6); }
}

</style>
